<template>
  <div class="topic-asset-association-container">
    <template v-if="currentTopic">
      <topic
        :subtopic="currentSubtopic"
        :topic="currentTopic"
        @accordion-toggled="handleAccordionToggle"
      />
    </template>
  </div>
</template>

<script>
import Topic from '@components/topics/topic';

export default {
  components: { Topic },
  props: {
    assetAssociation: {
      type: Object,
    },
  },
  data() {
    return {
      currentSubtopic: undefined,
    };
  },
  computed: {
    currentTopic() {
      if (this.assetAssociation) {
        return this.$store.getters['topics/topics'][this.assetAssociation.assetBId];
      }
    },
  },
  watch: {
  'assetAssociation': {
      immediate: true,
      handler: function(newAA, oldAA) {
        if (newAA) {
          let topicId = newAA.assetBId;
          if (topicId && !this.$store.getters['topics/topics'][topicId]) {
            this.$store.dispatch('topics/load', { ids: [topicId] });
          }
        }
      },
    },
  },
  methods: {
    handleNestedSubtopicSelected(data) {
      this.currentSubtopic = data.subtopic;
    },
    handleAccordionToggle([closed, subtopic]) {
      this.currentSubtopic = closed ? undefined : subtopic;
    },
    handleModalTopicBack(data) {
      this.currentSubtopic = data.subtopic ? data.subtopic.id : undefined;
    },
  },
};
</script>

<style lang='scss' scoped>
.topic-asset-association-container {
  background: white;
  height: 100%;
  overflow-y: scroll;

  .topic-modal-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }
}
</style>
